import React from 'react';
import '@amzn/awsui-components-react/index.css';
import {Icon, Table, Modal, AttributeEditor, Input} from "@amzn/awsui-components-react";
import TableFiltering from "@amzn/awsui-components-react/polaris/table-filtering";
import Button from "@amzn/awsui-components-react/polaris/button";
import TableSorting from "@amzn/awsui-components-react/polaris/table-sorting";

class ICDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {modalVal: null, saving: false};
  }

  handleDetails = (integrationId) => {
    this.props.onReviewDetails(integrationId);
  }

  modalKeyChange = (event, index) => {
    let newModalVal = [...this.state.modalVal];
    let item = newModalVal[index];
    item.key = event.detail.value;
    this.setState({modalVal: newModalVal});
  }

  modalKey = (item, index) => <Input value={item.key} placeholder="Enter key"
                                     onInput={(event) => this.modalKeyChange(event, index)}/>

  modalValueAddClick = (index) => {
    let newModalVal = [...this.state.modalVal];
    let item = {...newModalVal[index]};
    if (item.value === null) {
      item.value = [];
    } else {
      item.value = [...item.value];
    }
    item.value.push('');
    newModalVal[index] = item;
    this.setState({modalVal: newModalVal});
  }

  modalValueRemoveClick = (event, index) => {
    let newModalVal = [...this.state.modalVal];
    let item = {...newModalVal[index]};
    item.value = [...item.value];
    item.value.splice(event.detail.itemIndex, 1);
    if (item.value.length === 0) {
      item.value = null;
    }
    newModalVal[index] = item;
    this.setState({ modalVal: newModalVal });
  }

  modalValueControl = (nestedItem, nestedIndex, index) => <Input value={nestedItem}
                                                                 onInput={(event) =>
                                                                   this.modalValueControlChange(event, nestedIndex, index)}
  />

  modalValueControlChange = (event, nestedIndex, index) => {
    let newModalVal = [...this.state.modalVal];
    let item = {...newModalVal[index]};
    item.value[nestedIndex] = event.detail.value;
    newModalVal[index] = item;
    this.setState({modalVal: newModalVal});
  }

  modalValueInputChange = (event, index) => {
    let newModalVal = [...this.state.modalVal];
    let item = {...newModalVal[index]};
    item.value = event.detail.value;
    newModalVal[index] = item;
    this.setState({modalVal: newModalVal});
  }

  modalValue = (item, index) => {
    if (item.key === "includeResults") {
      let controlItem = item.value;
      if (item.value === '' || item.value === null) {
        controlItem = [];
      }
      return <AttributeEditor
        empty='No agreements'
        addButtonText='Add'
        removeButtonText='Remove'
        items={controlItem}
        onAddButtonClick={() => this.modalValueAddClick(index)}
        onRemoveButtonClick={(event) => this.modalValueRemoveClick(event, index)}
        definition={[{label: "Agreement", control: (nestedItem, nestedIndex) => this.modalValueControl(nestedItem, nestedIndex, index)}]}/>
    }
    if (item.key === "calculationDetails") {
      return <Input value={JSON.stringify(this.state.modalVal[index].value)} disabled={true}/>;
    }
    return <Input value={item.value} placeholder="Enter value" onInput={(event) => this.modalValueInputChange(event, index)}/>
  }

  modalInfo = () => {
    if (this.state.modalVal === null) {
      return '';
    }
    return <AttributeEditor
      empty='No attributes found here'
      addButtonText="Add new item"
      removeButtonText="Remove"
      items={this.state.modalVal}
      onAddButtonClick={() => {this.setState({modalVal: [...this.state.modalVal, {key: '', value: ''}]})}}
      isItemRemovable={() => false}
      disableAddButton={true}
      onRemoveButtonClick={(event) => {
        const items = [...this.state.modalVal];
        items.splice(event.detail.itemIndex, 1);
        this.setState({ modalVal: items });
      }}
      definition={[
        {
          label: "Key",
          control: (item, index) => this.modalKey(item, index)
        },
        {
          label: "Value",
          control: (item, index) => this.modalValue(item, index)
        }
      ]}/>
  }

  objectToKeyVal = (obj) => {
    return Object.keys(obj).map((key) => {
      return {key: key, value: obj[key]}
    });
  }

  keyValToObj = (keyVal) => {
    return keyVal.reduce((result, item) => {
      result[item.key] = item.value;
      return result;
    }, {});
  }

  saveDetails = (e) => {
    let modState = this.keyValToObj(this.state.modalVal);
    if (modState.includeResults === null) {
      delete modState.includeResults
    }
    this.setState({saving: true}, async () => {
      await this.props.handleSave(modState);
      this.setState({modalVal: null, saving: false});});
    e.preventDefault();
    e.stopPropagation();
  }

  rowDetails = row => <a href='#' onClick={(e) => {
    e.preventDefault();
    this.handleDetails(row.id);
  }}>View Detail</a>

  editRow = row => <a href='#' onClick={(e) => {this.setState({modalVal: this.objectToKeyVal(row)})}}>
    <Icon name="edit"/>
  </a>

  dismiss = (e) => {
    if (this.state.saving) {
      e.preventDefault();
    }
  }


  render() {
    let columnDef = [
      {
        header: 'Integration Name',
        id: 'integrationName',
        cell: item => item.integrationName,
        minWidth: '220px',
      },
      {
        header: 'Integration Type',
        id: 'integrationType',
        cell: item => item.integrationType,
        minWidth: '120px',
      },
      {
        header: 'Calculation',
        id: 'calculation',
        cell: item => item.calculation,
        minWidth: '120px',
      },
      {
        header: 'Agreement Number',
        id: 'agreementNumber',
        cell: item => item.agreementNumber,
        minWidth: '90px',
      },
      {
        header: 'Source System',
        id: 'sourceSystem',
        cell: item => item.sourceSystem,
        minWidth: '120px',
      },
      {
        header: 'Target System',
        id: 'targetSystem',
        cell: item => item.targetSystem,
        minWidth: '120px',
      },
      {
        header: 'Data Type',
        id: 'dataType',
        cell: item => item.dataType,
        minWidth: '90px',
      },
      {
        header: 'Details',
        id: 'details',
        cell: (row) => this.rowDetails(row),
        minWidth: '120px',
      },
      {
        header: 'Edit',
        id: 'edit',
        cell: (row) => this.editRow(row)
      }
    ];
    return (
      <React.Fragment>
      <Table
        columnDefinitions={columnDef}
        items={this.props.items}
        features={['filtering', 'sorting']}
        loading={false}
        loadingText="Searching..."
        resizableColumns={true}
        wrapLines={false}
        header={<h2>Onboarded Usecases</h2>}
        empty={<div className="awsui-util-t-c">
          <div className="awsui-util-pt-s awsui-util-mb-xs">
            <b>
              No resources
            </b>
          </div>
          <p className="awsui-util-mb-s">
            No resources to display.
          </p>
        </div>}
        noMatch={<div className="awsui-util-t-c">
          <div className="awsui-util-pt-s awsui-util-mb-xs">
            <b>
              No matches
            </b>
          </div>
          <p className="awsui-util-mb-s">
            We can’t find a match.
          </p>
          <div className="awsui-util-mb-m">
            <Button onClick={() => this.setState({filterText: ''})}>
              Clear filter
            </Button>
          </div>
        </div>}
      >
        <TableFiltering
          filteringCountTextFunction={count => `${count} ${count === 1 ? 'match' : 'matches'}`}
          filteringText={this.props.filterText}
          filteringFields={['integrationName', 'integrationType', 'calculation', 'agreementNumber', 'sourceSystem', 'targetSystem', 'dataType']}
          onFilteringDelayedInput={(e) => {this.props.onDelayedFilter(e)}}
        />
        <TableSorting sortingColumn="integrationName"
                      sortableColumns={[{id: 'integrationName', field: 'integrationName'},
                        {id: 'integrationType', field: 'integrationType'}, {id: 'calculation', field: 'calculation'},
                        {id: 'agreementNumber', field: 'agreementNumber'}, {id: 'sourceSystem', field: 'sourceSystem'},
                        {id: 'targetSystem', field: 'targetSystem'}, {id: 'dataType', field: 'dataType'}]}>
        </TableSorting>
      </Table>
      <Modal
        size='max'
        visible={this.state.modalVal !== null || this.state.saving}
        header="Edit Entry"
        onDismiss={(e) => this.dismiss(e)}
        footer={<span className="awsui-util-f-r">
                <Button variant="link" disabled={this.state.saving} onClick={(e) => {this.setState({modalVal: null})}}>
                  Cancel
                </Button>
                <Button variant="primary" disabled={this.state.saving} onClick={(e) => {this.saveDetails(e)}}>
                  Save
                </Button>
              </span>}
      >
        {this.modalInfo()}
      </Modal>
      </React.Fragment>
    );
  }
}

export default ICDashboard;